import React from 'react'
import styled from 'styled-components'
import { SvgAttr } from '../SvgAttr/SvgAttr'

export const IconYoutube = ({
  classes = '',
  styles,
  width = '40px',
  height = '40px',
  color = 'currentColor',
}) => {
  return (
    <Svg
      viewBox='0 0 72 72'
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      className={classes}
      width={width}
      height={height}
      styles={styles}
    >
      <title>Youtube</title>
      <Path
        color={color}
        d='M38.26,63.7h-4.53c-.82-.19-1.68-.21-2.51-.36-11.33-1.96-20.57-11.16-22.5-22.52-.14-.83-.17-1.69-.36-2.51.07-1.48-.1-3.06,0-4.54.81-11.96,10.24-22.38,21.89-24.81,21.05-4.38,38.91,15.82,31.86,36.2-3.46,10-13.18,17.79-23.86,18.52ZM29.81,25.28c-1.38.04-2.99.05-4.35.19-1.58.16-3.09.55-3.87,2.06-1.41,2.71-1.19,10.82-.82,13.97.53,4.52,2.35,5.02,6.53,5.24,4.9.26,10.09.15,15,0s8.24.66,8.91-5.34c.36-3.27.36-7.42,0-10.69-.64-5.92-3.86-5.18-8.69-5.34-4.21-.14-8.48-.2-12.7-.08Z'
      />
      <Polygon
        color={color}
        points='32.86 31.4 41.06 35.67 32.86 40.04 32.86 31.4'
      />
    </Svg>
  )
}

const Svg = styled(SvgAttr)`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  ${(props) => props.styles}
`

const Path = styled.path`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`

const Polygon = styled.polygon`
  transition: all 0.2s ease-in-out;
  fill: ${(props) => props.color};
`
